import * as React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ContainerWithFooter, FeatureBox, InputCardDetailsForm, Loader, PaymentInformation } from '../components';
import { CardDetailsModal } from '../components/modals';
import { Details, FlexWrappedRow, LinkRight, MainTitle, SpaceBetween, TitleAlignLeft } from '../components/styled';
import { appActions } from '../store/ducks/app';

const mapStateToProps = (state: any) => ({
  loading: state.appData.loading,
  general: state.appData.general,
  user: state.appData.user,
});

type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  loadUser: () => void;
  startOtherPaymentMethod: () => void;
}

type Props = StateProps & DispatchProps;

class Complete extends React.Component<Props> {
  componentDidMount() {
    this.props.loadUser();
  }

  render() {
    if (this.props.loading || !this.props.general.products) {
      return <Loader />;
    }
    return (
      <ContainerWithFooter>
        <MainTitle>
          <FormattedMessage id="title_complete" values={{ br: <br /> }} />
        </MainTitle>
        <FlexWrappedRow>
          <FeatureBox />
          <Details>
            <SpaceBetween>
              <TitleAlignLeft>
                <FormattedMessage id="card_details" />
              </TitleAlignLeft>
              <LinkRight onClick={this.props.startOtherPaymentMethod}>
                <FormattedMessage id="other_payment_methods" />
              </LinkRight>
            </SpaceBetween>
            { this.props.user?.paymentMethod ? <PaymentInformation /> : <InputCardDetailsForm /> }
          </Details>
        </FlexWrappedRow>
        <CardDetailsModal />
      </ContainerWithFooter>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, appActions)(Complete);
